import { useMemo } from "react";
import type { ProtoShotPassDetail } from "@catbento/shared";
import { readSnapshot } from "../data/snapshot.js";
import { getShotPassDetail } from "../data/shot-pass.js";

// Phase 02 seam: one player's shot/pass detail (Shot Map / Pass Map / Passing
// Profile + the Matches shot/pass overlays). Keyed by the player's numeric id
// (shotPassDetail is id-keyed, not name-keyed). Returns null when the player has
// no captured events (sparse data — the renderer honestly plots nothing). For the
// Matches overlay, feed the result to `flattenEventsByMatch`. At the Part-2
// cutover this hook fetches GET /player-shots + /player-passes and adapts to the
// same ProtoShotPassDetail shape.
export function useShotPassEvents(playerId: number): ProtoShotPassDetail | null {
  return useMemo(() => getShotPassDetail(readSnapshot(), playerId), [playerId]);
}
